export enum FrontendType {
  customer = 'customer',
  admin = 'admin',
  cosmos = 'cosmos'
}
